__turbopack_context__.v({
  "chevron": "WDropDownMenu-module__oi5RMa__chevron",
  "chevronToggle": "WDropDownMenu-module__oi5RMa__chevronToggle",
  "devMockBanner": "WDropDownMenu-module__oi5RMa__devMockBanner",
  "empty": "WDropDownMenu-module__oi5RMa__empty",
  "l2Header": "WDropDownMenu-module__oi5RMa__l2Header",
  "l2HeaderActive": "WDropDownMenu-module__oi5RMa__l2HeaderActive",
  "l2HeaderArrow": "WDropDownMenu-module__oi5RMa__l2HeaderArrow",
  "l2HeaderInPath": "WDropDownMenu-module__oi5RMa__l2HeaderInPath",
  "l2HeaderName": "WDropDownMenu-module__oi5RMa__l2HeaderName",
  "l2Section": "WDropDownMenu-module__oi5RMa__l2Section",
  "nestedItem": "WDropDownMenu-module__oi5RMa__nestedItem",
  "nestedLink": "WDropDownMenu-module__oi5RMa__nestedLink",
  "nestedLinkActive": "WDropDownMenu-module__oi5RMa__nestedLinkActive",
  "nestedList": "WDropDownMenu-module__oi5RMa__nestedList",
  "panel": "WDropDownMenu-module__oi5RMa__panel",
  "panelGrid": "WDropDownMenu-module__oi5RMa__panelGrid",
  "root": "WDropDownMenu-module__oi5RMa__root",
  "seeAll": "WDropDownMenu-module__oi5RMa__seeAll",
  "topBar": "WDropDownMenu-module__oi5RMa__topBar",
  "topBarItem": "WDropDownMenu-module__oi5RMa__topBarItem",
  "topBarLink": "WDropDownMenu-module__oi5RMa__topBarLink",
  "topBarLinkActive": "WDropDownMenu-module__oi5RMa__topBarLinkActive",
  "topBarLinkInPath": "WDropDownMenu-module__oi5RMa__topBarLinkInPath",
  "topBarLinkMock": "WDropDownMenu-module__oi5RMa__topBarLinkMock",
  "topBarLinkOpen": "WDropDownMenu-module__oi5RMa__topBarLinkOpen",
});
